import _ from 'lodash'
import { extractLayoutToNonCoveredRanges, LayoutWithBreakpointRange } from './layoutToNonCoveredRanges'
import { SelectorToCssMap } from './layoutToCss'
import { LayoutDataItems, ItemLayouts } from '@wix/thunderbolt-becky-types'

interface CssWithMedia {
	[mediaQuery: string]: SelectorToCssMap
}

export interface BreakpointsToCssWithMedia {
	[breakpointId: string]: CssWithMedia
}

export const mergeCssWithMediaArray = (array: Array<BreakpointsToCssWithMedia>) =>
	array.reduce(_.merge, {}) as BreakpointsToCssWithMedia

const extractHiddenToNonCoveredRanges = extractLayoutToNonCoveredRanges('ComponentLayout', 'hidden', (v) => !!v)
const extractAspectRatioToNonCoveredRanges = extractLayoutToNonCoveredRanges(
	'ComponentLayout',
	'height',
	(v) => !!v && v.type === 'aspectRatio'
)
const extractStickyToNonCoveredRanges = (type: ItemLayouts['type']) =>
	extractLayoutToNonCoveredRanges(type, 'position', (v) => !!v && v === 'sticky', ['top', 'bottom', 'left', 'right'])

export const extractPropertiesToNonCoveredRanges = <T extends LayoutDataItems>(
	layouts: Array<LayoutWithBreakpointRange<T>>,
	bpOrder: Array<string>
) => {
	const itemLayoutTypes: Array<ItemLayouts['type']> = [
		'GridItemLayout',
		'FixedItemLayout',
		'FlexItemLayout',
		'StackItemLayout',
		'OrganizerItemLayout',
	]
	const layoutsAfterHiddenExtraction = extractHiddenToNonCoveredRanges(layouts, bpOrder)
	let layoutsAfterStickyExtraction = layoutsAfterHiddenExtraction
	_.forEach(itemLayoutTypes, (type) => {
		layoutsAfterStickyExtraction = extractStickyToNonCoveredRanges(type)(layoutsAfterStickyExtraction, bpOrder)
	})
	return extractAspectRatioToNonCoveredRanges(layoutsAfterStickyExtraction, bpOrder)
}

export { layoutDataItemToCss } from './layoutToCss'
